<div class="custom-button">
  @switch (buttontype?.type) {
    @case ('confirm') {
      <button class="custom-button__confirm" [ngClass]="buttontype.customclass" #dynamicbutton
        [disabled]='buttontype.disbaledproperity' mat-raised-button (click)="handleclick($event)"><i class="btn-icon"
      [ngClass]="buttontype.icon"></i>
      <span>{{ buttontype.label | translate }}</span></button>
    }
    @case ('cancel') {
      <button class="custom-button__cancel" [ngClass]="buttontype.customclass" #dynamicbutton
        [disabled]='buttontype.disbaledproperity' mat-raised-button (click)="handleclick($event)"><i class="btn-icon"
      [ngClass]="buttontype.icon"></i> {{ buttontype.label | translate }}</button>
    }
    @case ('option') {
      <button class="custom-button__option default-form-field" [ngClass]="buttontype.customclass" #dynamicbutton
        [disabled]='buttontype.disbaledproperity' mat-raised-button
        appCustomStyle
        (click)="handleclick($event)"><i class="btn-icon" [ngClass]="buttontype.icon"></i> {{ buttontype.label |
      translate }}</button>
    }
    @case ('action-primary') {
      <button class="primary-orange action-primary" [ngClass]="buttontype.customclass" #dynamicbutton
        [disabled]='buttontype.disbaledproperity' mat-raised-button
        (click)="handleclick($event)"><i class="btn-icon" [ngClass]="buttontype.icon"></i> {{ buttontype.label |
        translate }}
        @if (buttontype.additionalText) {
          <span class="d-block rs-Roboto-Regular-10">{{buttontype.additionalText |
          translate}}</span>
        }</button>
      }
      @case ('action-secondary') {
        <button class="secondary action-secondary" [ngClass]="buttontype.customclass" #dynamicbutton
          [ngStyle]="buttontype.customStyle" [disabled]='buttontype.disbaledproperity'
          mat-raised-button (click)="handleclick($event)"><i class="btn-icon" [ngClass]="buttontype.icon"></i> {{
          buttontype.label |
          translate }}
          @if (buttontype.additionalText) {
            <span class="d-block rs-Roboto-Regular-10">{{buttontype.additionalText |
            translate}}</span>
          }</button>
        }
      }
    </div>